import React, { useEffect, useState } from "react";
import "../../style/Plans/_PlanDetails.scss";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Assistence } from "../../assets/new-icons/assistenza.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as SadFace } from "../../assets/new-icons/tradizionaleFace.svg";
import { ReactComponent as RelaxFace } from "../../assets/new-icons/relaxFace.svg";
import { ReactComponent as HappyFace } from "../../assets/new-icons/ricaricabileFace.svg";
import Tradizionale from "./PlanDetails/_Tradizionale";
import Ricaricabile from "./PlanDetails/_Ricaricabile";
import Relax from "./PlanDetails/_Relax";

function PlanDetails() {
  const navigate = useNavigate();
  const currentPlan = useSelector((user) => user?.user?.idGruppo);
  const [showScroll, setShowScroll] = useState(false); 

  const getPlanName = () => {
    switch (currentPlan) {
      case 1:
        return "Ricaricabile";
      case 2:
        return "Relax";
      case 3:
        return "Tradizionale";
      default:
        break;
    }
  };
  const getPlanFace = () => {
    switch (currentPlan) {
      case 1:
        return <HappyFace />;
      case 2:
        return <RelaxFace />;

      case 3:
        return <SadFace />;
      default:
        break;
    }
  };
  const getPlanDescription = () => {
    switch (currentPlan) {
      case 1:
        return "Carica, consuma, ricarica.";
      case 2:
        return "Rilassati con un prezzo conveniente";

      case 3:
        return "Ricarica una volta al mese";
      default:
        break;
    }
  };
  return (
    <div
      className={`planDetail ${
        currentPlan === 3 ? "red" : currentPlan === 2 ? "orange" : "green"
      }`}
    >
      <div className="planDetail-top">
        <header >
          <div className="navigation" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
            <p className="secondary bold">Il tuo piano</p>
          </div>
          <div className="assistence">
            <Assistence />
          </div>
        </header>
        <div className="text">
          <div className="icon">{getPlanFace()}</div>
          <p className="secondary">{getPlanName()}</p>
          <p className="main">{getPlanDescription()}</p>
        </div>
      </div>
      <div className="planDetail-bottom">
        {currentPlan === 3 ? (
          <Tradizionale />
        ) : currentPlan === 2 ? (
          <Relax />
        ) : (
          <Ricaricabile />
        )}
      </div>
    </div>
  );
}

export default PlanDetails;
